/* Herlamora newsletter — submits signups to Klaviyo's client
   subscriptions API when a public API key (company id) and list id are
   configured on the section. Without them the native Shopify customer
   form submits normally (no interception). */

class HerlamoraNewsletter extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.companyId = this.dataset.company;
    this.listId = this.dataset.list;
    if (!this.form || !this.companyId || !this.listId) return;

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.subscribe();
    });
  }

  message(text, isError) {
    const slot = this.querySelector('[data-message]');
    if (!slot) return;
    slot.textContent = text;
    slot.classList.toggle('is-error', Boolean(isError));
    slot.classList.add('is-visible');
  }

  async subscribe() {
    const emailInput = this.querySelector('[data-email-input]');
    const nameInput = this.querySelector('[data-name-input]');
    const submitButton = this.querySelector('[data-submit]');
    if (!emailInput || !emailInput.value) return;

    const attributes = { email: emailInput.value.trim() };
    if (nameInput && nameInput.value.trim()) attributes.first_name = nameInput.value.trim();

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: this.dataset.source || 'Newsletter',
          profile: {
            data: {
              type: 'profile',
              attributes,
            },
          },
        },
        relationships: {
          list: {
            data: { type: 'list', id: this.listId },
          },
        },
      },
    };

    if (submitButton) submitButton.disabled = true;

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.companyId)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-10-15',
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        const fields = this.querySelector('.hnl__fields');
        if (fields) fields.remove();
        if (submitButton) submitButton.remove();
        this.message(this.dataset.success || 'Danke für deine Anmeldung!', false);
      } else {
        if (submitButton) submitButton.disabled = false;
        this.message(this.dataset.error || 'Das hat leider nicht geklappt.', true);
      }
    } catch (error) {
      if (submitButton) submitButton.disabled = false;
      this.message(this.dataset.error || 'Das hat leider nicht geklappt.', true);
    }
  }
}

if (!customElements.get('herlamora-newsletter')) {
  customElements.define('herlamora-newsletter', HerlamoraNewsletter);
}
